'use strict';

const createWidget = require('./create_widget').default;

const getResources = ({name}) => {
    return Odigeo._.isString(name) ?
        Odigeo.Templates.getWidgetTemplate(name) : Promise.resolve({});
};

module.exports = function(config) {
    return {
        create(options = {}) {
            return createWidget(config, options, getResources);
        },
    };
};
